import React from "react"
import { createRoot } from "react-dom/client"

function Dashboard({ role, roleLabel, greeting, headline, intro, placeholders, badge }) {
  return (
    <section className="dashboard" data-role={role}>
      <header className="dashboard__head">
        <span className="dashboard__role-badge">{roleLabel}</span>
        <p className="dashboard__greeting">{greeting}</p>
      </header>

      <h1 className="dashboard__headline">{headline}</h1>
      <p className="dashboard__intro">{intro}</p>

      <div className="dashboard__cards">
        {(placeholders || []).map((label, index) => (
          <article className="card card--placeholder" key={index}>
            <span className="card__badge">{badge}</span>
            <h2 className="card__title">{label}</h2>
          </article>
        ))}
      </div>
    </section>
  )
}

function mount() {
  const el = document.getElementById("dashboard")
  if (!el || el.dataset.mounted === "true") return

  let props = {}
  try {
    props = JSON.parse(el.dataset.props || "{}")
  } catch (error) {
    console.error("Invalid dashboard props", error)
  }

  el.dataset.mounted = "true"
  createRoot(el).render(<Dashboard {...props} />)
}

// Works both on a normal load and on Turbo navigations.
document.addEventListener("turbo:load", mount)
document.addEventListener("DOMContentLoaded", mount)
